<template>


 <div>
   <b-button
           @click="showPrint" size="-small" variant="-secondary">{{$t('files.base.print')}}
   </b-button>

   <!--<b-dropdown v-if="!isPrintersLoaded || !canPrintOrQueue"-->
               <!--@click="showPrint"-->
               <!--variant="-secondary"-->
               <!--size="-small"-->
               <!--:text="$t('files.base.print')"-->
               <!--split-->
               <!--right>-->
     <!--<b-dropdown-text style="width: 240px;">-->
       <!--No available printers-->
     <!--</b-dropdown-text>-->
   <!--</b-dropdown>-->


   <!--<b-dropdown v-else-->
               <!--@click="showPrint" split-->
               <!--:disabled="processing"-->
               <!--variant="-secondary"-->
               <!--size="-small"-->
               <!--:text="$t('files.base.print')"-->
               <!--right>-->
     <!--<b-dropdown-group header="Print" v-if="printersList.print.length">-->
       <!--<b-dropdown-item-button v-for="printer in printersList.print"-->
                               <!--:key="printer.id"-->
                               <!--@click="handleStartPrint(printer.id)">-->
         <!--{{printer.name}}-->
       <!--</b-dropdown-item-button>-->
     <!--</b-dropdown-group>-->
     <!--<b-dropdown-group header="Queue" v-if="printersList.queue.length">-->
       <!--<b-dropdown-item-button v-for="printer in printersList.queue"-->
                               <!--:key="printer.id"-->
                               <!--@click="handleStartQueue(printer.id)">-->
         <!--{{printer.name}}-->
       <!--</b-dropdown-item-button>-->
     <!--</b-dropdown-group>-->
   <!--</b-dropdown>-->
 </div>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";
  import PrinterMixin from "@/mixins/printer";

  export default {
    name: 'file-print-button',
    props: ['file'],
    mixins: [PrinterMixin],
    data() {
      return {
        processing: false
      }
    },
    computed: {
      ...mapGetters(['isPrintersLoaded', 'getActivePrinters', 'getJobsByPrinter', 'getPrintSettings']),

      canPrintOrQueue() {
        return this.printersList.print.length > 0 || this.printersList.queue.length > 0;
      },

      printersList() {
        let printers = {queue: [], print: []};
        if (this.isPrintersLoaded) {
          for (let i in this.getActivePrinters) {
            const printer = this.getActivePrinters[i];
            if (printer.printer_type != this.file.printer_type) {
              continue;
            }
            const canQueue = this.canAddToPrinterQueue(printer) && !this.isDisabledQueue(printer);
            const canPrint = this.canPrintOnPrinter(printer) && !this.isDisabledPrint(printer);
            if (!canQueue && !canPrint) {
              continue;
            }
            let maxJobTime = 0;
            this.getJobsByPrinter(printer.printer_id).map(job => {
              if (job.added_to_queue_ts > maxJobTime) {
                maxJobTime = job.added_to_queue_ts;
              }
            });
            const data = {
              id: printer.printer_id,
              name: this.calculatePrinterName(printer),
              maxJobTime
            };
            if (canPrint) {
              printers.print.push(data);
            } else {
              printers.queue.push(data);
            }
          }
          for (let type in printers) {
            printers[type] = printers[type].sort((a, b) => {
              if (a.maxJobTime === b.maxJobTime) {
                return 0;
              }

              return a.maxJobTime < b.maxJobTime ? 1 : -1;
            }).slice(0, 3);
          }
        }
        return printers;
      }
    },

    methods: {
      ...mapActions(['printFile']),

      showPrint() {
        window.vuePrintFile(this.file.id, this.file.printer_type);
      },

      handleStartQueue(printerId) {
        this.processing = true;
        this.printFile({fileId: this.file.id, printerId: printerId, onlyQueue: true}).then(({data}) => {
          this.processing = false;
          if (data.result) {
            this.toastHtml(this.$t('printers.modal.choosePrinter.successQueue') + ' <a href="/#/printers" onclick="closeToast(this)">'+this.$t('printers.modal.choosePrinter.goToPrinters')+'</a>', {
              variant: 'success'
            });
            this.$emit('close');
          } else {
            this.msgBoxOk(data.message, {title: 'Queue job'});
          }
        });
      },

      handleStartPrint(printerId) {
        this.processing = true;
        this.printFile({fileId: this.file.id, printerId: printerId, onlyQueue: false}).then(({data}) => {
          this.processing = false;
          if (data.result) {
            this.toastHtml(this.$t('printers.modal.choosePrinter.successPrint') + ' <a href="/#/printers" onclick="closeToast(this)">'+this.$t('printers.modal.choosePrinter.goToPrinters')+'</a>', {
              variant: 'success'
            });
            this.$emit('close');
          } else {
            this.msgBoxOk(data.message, {title: 'Print job'});
          }
        });
      },
    }
  }
</script>
